"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _api = require("../../api/api.js");
var _default = exports.default = {
  data: function data() {
    return {
      detailData: ''
    };
  },
  mounted: function mounted() {
    this.getData();
  },
  methods: {
    getData: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var jsonParam, _yield$apiGetDataStat, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              jsonParam = {
                jsonParamete: JSON.stringify({
                  fun: "findDataStatisticsPc",
                  param: {},
                  version: 1
                })
              };
              _context.next = 3;
              return (0, _api.apiGetDataStatisticsPc)(jsonParam);
            case 3:
              _yield$apiGetDataStat = _context.sent;
              data = _yield$apiGetDataStat.data;
              if (data.proCode == 200) {
                this.detailData = data.proData;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }()
  }
};